import { useParams } from 'next/navigation';

export const useGetUserIdFromParams = () => {
  const { userId } = useParams<{ locale: string; userId: string }>();
  return Number(userId);
};
